const RETRY_BASE_DELAYS_MS = [300, 900, 2100]
const JITTER_MAX_MS = 200

export const getRateLimitDelayMs = (attemptNumber) => {
  const attemptIndex = Math.max(0, Number(attemptNumber || 1) - 1)
  const baseDelay = RETRY_BASE_DELAYS_MS[attemptIndex] || RETRY_BASE_DELAYS_MS[RETRY_BASE_DELAYS_MS.length - 1]
  const jitter = Math.floor(Math.random() * JITTER_MAX_MS)

  return baseDelay + jitter
}

export const waitForRetryDelay = (delayMs) => new Promise((resolve) => {
  setTimeout(resolve, Math.max(0, Number(delayMs) || 0))
})
